import { Controller } from 'stimulus'

export default class NotificationPreferences extends Controller {
  static targets = ["allEmail", "allPush", "email", "push"]

  connect() {
    this.syncAll()
  }

  toggleAllEmail() {
    if (!this.hasAllEmailTarget) return

    const checked = this.allEmailTarget.checked
    this.emailTargets.forEach(cb => { cb.checked = checked })
  }

  toggleAllPush() {
    if (!this.hasAllPushTarget) return

    const checked = this.allPushTarget.checked
    this.pushTargets.forEach(cb => { cb.checked = checked })
  }

  syncAll() {
    this.syncAllEmail()
    this.syncAllPush()
  }

  syncAllEmail() {
    if (!this.hasAllEmailTarget) return

    const allChecked = this.emailTargets.length > 0 && this.emailTargets.every(cb => cb.checked)
    this.allEmailTarget.checked = allChecked
  }

  syncAllPush() {
    if (!this.hasAllPushTarget) return

    const allChecked = this.pushTargets.length > 0 && this.pushTargets.every(cb => cb.checked)
    this.allPushTarget.checked = allChecked
  }

  autoSave() {
    this.element.closest("form").requestSubmit()
  }
}
